import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import useFetchHelpCenter from './fetch/useFetchHelpCenter';
import useMutateLiveChat from './mutate/useMutateLiveChat';

const INTERVAL = 1000;

export default function useRefetchOnExpiration() {
  const client = useQueryClient();
  const { data } = useFetchHelpCenter();
  const { mutate: updateLiveChat } = useMutateLiveChat();

  const expirationDate = data?.valid_until_date_str;
  const uuid = data?.uuid;

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    const randomDelay = Math.random() * 10 * 60 * 1000;
    const interval = setInterval(() => {
      const currentTime = Date.now();
      const expirationTime = new Date(expirationDate || currentTime).getTime();
      const diff = expirationTime - currentTime;

      if (diff < 0) {
        (async () => {
          clearInterval(interval);
          timeout = setTimeout(async () => {
            await client.invalidateQueries({ queryKey: ['helpCenter'] });
            updateLiveChat({ uuid, scenarioChange: true });
          }, randomDelay);
        })();
      }
    }, INTERVAL);

    return () => {
      clearInterval(interval);
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [client, expirationDate, uuid, updateLiveChat]);
}
